import PropTypes from 'prop-types';
import React from 'react';
import styles from './documentStyles.scss';

const DocumentLink = (props) => {
  const { children, href } = props;
  return (
    <a
      href={href}
      className={styles.documentNameLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

DocumentLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
};

export default DocumentLink;



// WEBPACK FOOTER //
// ./client/app/shared/components/DocumentsTable/documentLink.jsx